import { Component, OnInit, Inject } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { ContactApiService } from '../../data-services/index';

import { IApplicationPayment, IContact, IDwelling } from '@ebb-v2/ebb-integration';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';

export interface IDataPaymentAuthorizationForm {
  applicationPayment: IApplicationPayment;
  applicationOwner: IContact;
  applicationContractor: IContact;
  applicationDweling: IDwelling;
  pafCompany: string;
  pafFullName: string;
  pafTypeCode: number;
  pafAddressStreet: string;
  pafAddressCity: string;
  pafAddressState: string;
  pafAddressZip: string;
  pafAuthorizationDate: Date;
  programType:number;
}

@Component({
  selector: 'ebb-portal-dialog-paform',
  templateUrl: './dialog-paform.component.html'
})
export class DialogPaformComponent implements OnInit {
  public formPayeeInfo: FormGroup;
  public formPropertyInfo: FormGroup;
  public isDoItYourself = false;
  public currentPayee: number = null;
  public payeeIsHomeowner = false;
  public payeeIsContractor = false;
  public currentDate: Date = new Date();
  public homeOwnerLabel ="Homeowner";
  constructor(
    public readonly dialogRef: MatDialogRef<DialogPaformComponent>,
    private readonly fb: FormBuilder,
    private readonly apiContact: ContactApiService,
    @Inject(MAT_DIALOG_DATA) public data: IDataPaymentAuthorizationForm
  ) { }

  ngOnInit() {
    if(this.data.programType === 700000004){
      this.homeOwnerLabel ="Property Owner"
    }
    this.initializeForms();
    this.loadContactData();
    this.formPropertyInfo.get("pafAddressState").disable();
   
    if (this.data.applicationPayment) {
      this.formPayeeInfo.get('payeeTypeCode')?.setValue(this.data.applicationPayment.pafTypeCode.toString()); 
      this.formPropertyInfo.patchValue({
        pafFullName: this.data.applicationPayment.pafFullName,
        pafAddressStreet:this.data.applicationPayment.pafAddressStreet,
        pafAddressCity: this.data.applicationPayment.pafAddressCity,
        pafAddressZip: this.data.applicationPayment.pafAddressZip,
        pafAddressState:this.data.applicationPayment.pafAddressState
      });
    }
   // Mark the controls as dirty
Object.keys(this.formPropertyInfo.controls).forEach(key => {
  this.formPropertyInfo.get(key)?.markAsDirty();
});
// Mark the controls as dirty
Object.keys(this.formPayeeInfo.controls).forEach(key => {
  this.formPayeeInfo.get(key)?.markAsDirty();
});
  }

  private initializeForms(): void {
    // Owner: 700000000; Contractor: 700000001
    this.formPayeeInfo = this.fb.group({
      payeeTypeCode: ''
    });
    this.formPropertyInfo = this.fb.group({
    
      pafFullName: ['', [Validators.maxLength(100), Validators.required]],
      pafAddressStreet: ['', [Validators.maxLength(100), Validators.required]],
      pafAddressCity: ['', [Validators.maxLength(100), Validators.required]],
      pafAddressState: ['', [Validators.maxLength(100), Validators.required]],
      pafAddressZip: ['',[Validators.required]],   
    });
  }

  private loadContactData(): void {
    if (this.data.applicationOwner.id === this.data.applicationContractor.id) {
      this.isDoItYourself = true;
      this.currentPayee = 700000000;
      this.data.pafTypeCode = 700000000;
      this.data.pafCompany = '';
      this.data.pafFullName = this.data.applicationOwner.fullName;
      this.data.pafAddressStreet = this.data.applicationOwner.address1_Line1;
      this.data.pafAddressCity = this.data.applicationOwner.address1_City;
      this.data.pafAddressState = this.data.applicationOwner.address1_StateOrProvince;
      this.data.pafAddressZip = this.data.applicationOwner.address1_PostalCode;
    } else {
      if (this.data.applicationPayment) {
        this.formPayeeInfo.get('payeeTypeCode')?.setValue(this.data.applicationPayment.pafTypeCode.toString()); 
        if (this.data.applicationPayment.pafTypeCode === 700000000) {
          this.currentPayee = 700000000;
          this.payeeIsHomeowner = true;
          this.data.pafTypeCode = 700000000;
          this.data.pafCompany = '';
          this.data.pafFullName = this.data.applicationOwner.fullName;
          this.data.pafAddressStreet = this.data.applicationOwner.address1_Line1;
          this.data.pafAddressCity = this.data.applicationOwner.address1_City;
          this.data.pafAddressState = this.data.applicationOwner.address1_StateOrProvince;
          this.data.pafAddressZip = this.data.applicationOwner.address1_PostalCode;
        }
        if (this.data.applicationPayment.pafTypeCode === 700000001) {
          this.currentPayee = 700000001;
          this.payeeIsContractor = true;
          this.data.pafTypeCode = 700000001;
          this.data.pafCompany = this.data.applicationContractor.businessName;
          this.data.pafFullName = this.data.applicationContractor.fullName;
          (this.data.applicationContractor.address3_Line2 && this.data.applicationContractor.address3_Line2.length > 0)
            ? this.data.pafAddressStreet = `${this.data.applicationContractor.address3_Line1}, ${this.data.applicationContractor.address3_Line2}`
            : this.data.pafAddressStreet = this.data.applicationContractor.address3_Line1;
          this.data.pafAddressCity = this.data.applicationContractor.address3_City;
          this.data.pafAddressState = this.data.applicationContractor.address3_StateOrProvince;
          this.data.pafAddressZip = this.data.applicationContractor.address3_PostalCode;
        }
      }
    }
  }
  public onCheckPayeeControlValidators(controlName: string): boolean {
    const retVal = (this.formPropertyInfo.get(controlName).errors 
                      && (this.formPropertyInfo.get(controlName).dirty || this.formPropertyInfo.get(controlName).touched));
    return retVal;
  }
  public onChangeEventPayee(event: MatRadioChange): void {
    const selectedValue = parseInt(event.value.toString(), 10);
    if(selectedValue === 700000000 && this.data.programType === 700000004){
      this.currentPayee = 700000000;
      
// Reset data properties
Object.assign(this.data, {
  pafCompany: '',
  pafFullName: '',
  pafAddressStreet: '',
  pafAddressCity: '',
  pafAddressState: '',
  pafAddressZip: '',
});

// Set form control values
this.formPropertyInfo.patchValue({
  pafFullName: this.data.applicationDweling.ownerAssociation?.length > 0 
               ? this.data.applicationDweling.ownerAssociation 
               : '',
  pafAddressStreet: this.data.applicationOwner?.address1_Line1 || '',
  pafAddressCity: this.data.applicationOwner?.address1_City || '',
  pafAddressZip: this.data.applicationOwner?.address1_PostalCode || '',
  pafAddressState:'CA'


});



         // Mark the controls as dirty
Object.keys(this.formPropertyInfo.controls).forEach(key => {
  this.formPropertyInfo.get(key)?.markAsDirty();
});
// Mark the controls as dirty
Object.keys(this.formPayeeInfo.controls).forEach(key => {
  this.formPayeeInfo.get(key)?.markAsDirty();
});

    }else{
    if (selectedValue === 700000000) {
      this.currentPayee = 700000000;
      this.data.pafTypeCode = 700000000;
      this.data.pafCompany = '';
      this.data.pafFullName = this.data.applicationOwner.fullName;
      this.data.pafAddressStreet = this.data.applicationOwner.address1_Line1;
      this.data.pafAddressCity = this.data.applicationOwner.address1_City;
      this.data.pafAddressState = this.data.applicationOwner.address1_StateOrProvince;
      this.data.pafAddressZip = this.data.applicationOwner.address1_PostalCode;
    } else {
      this.currentPayee = 700000001;
      this.data.pafTypeCode = 700000001;
      this.data.pafCompany = this.data.applicationContractor.businessName;
      this.data.pafFullName = this.data.applicationContractor.fullName;
      (this.data.applicationContractor.address3_Line2 && this.data.applicationContractor.address3_Line2.length > 0)
      ? this.data.pafAddressStreet = `${this.data.applicationContractor.address3_Line1}, ${this.data.applicationContractor.address3_Line2}`
      : this.data.pafAddressStreet = this.data.applicationContractor.address3_Line1;
      this.data.pafAddressCity = this.data.applicationContractor.address3_City;
      this.data.pafAddressState = this.data.applicationContractor.address3_StateOrProvince;
      this.data.pafAddressZip = this.data.applicationContractor.address3_PostalCode;
    }
  }}

  public onClickSave(): void {
    this.data.pafTypeCode = this.currentPayee;
    this.data.pafAuthorizationDate = this.currentDate;
    if (this.data.pafTypeCode === 700000001 &&
        (this.data.pafCompany && this.data.pafCompany.length > 0)) {
      this.data.pafFullName = this.data.pafCompany;
    }
    this.dialogRef.close(this.data);
  }
  public  onClickSavePayeeInfo(): void {
    this.data.pafTypeCode = this.currentPayee;
    this.data.pafAuthorizationDate = this.currentDate;
 this.data.pafFullName =this.formPropertyInfo.get("pafFullName").value;
 this.data.pafAddressStreet =this.formPropertyInfo.get("pafAddressStreet").value;
 this.data.pafAddressCity =this.formPropertyInfo.get("pafAddressCity").value;
 this.data.pafAddressState =this.formPropertyInfo.get("pafAddressState").value;
 this.data.pafAddressZip =this.formPropertyInfo.get("pafAddressZip").value;

    this.dialogRef.close(this.data);
  }
 

  public onClickCancel(): void {
    this.dialogRef.close();
  }

}
